<template>
  <div class="md-layout">
    <div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-large-size-80 md-xlarge-size-70 page-container">
      <div class="md-layout md-gutter">
        <div class="md-layout-item">
          <h2 style="text-align:center">
            {{$t('submission-successful')}}
          </h2>
          <p style="text-align:center">
            {{$t('contact-us-thank-you')}}
          </p>
          <p class="text-right">
            <md-button to="/">{{$t('back-to-home')}}</md-button>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>


<script>

  export default {
    name: 'ContactUsSuccess',
    data: () => ({
      sending: false
    }),
    created() {
      this.$scrollTo('#app')
    },
    methods: {
      
    }
  }
</script>